export default "__VITE_ASSET__94556c92__"